const registeredErrorMessages = [
    'paypalUnauthorized',
    'invalidPaymentType',
    'paypalCaptureError',
    'invalidIban',
    'already_exists',
    'noAnonymousContact'
]

export default {
    async fetchNewsletterData({commit, state}, {newsletterId}) {
        try {
            commit('setNewsletterIsLoaded', false)
            let responseData = (await useNuxtApp().$axios.get(useNuxtApp().$apiRoute('api.newsletters.newsletters.show', {newsletter: newsletterId}),
                {
                    params: {
                        subscriberToken: state.subscriberToken
                    }
                })).data
            commit('setFormSelectChoices', responseData.formSelectChoices)
            commit('setNewsletterData', responseData.newsletterData)
            if (responseData.subscriptionData) {
                commit('setSubscriptionData', responseData.subscriptionData)
            } else {
                if (state.newsletterData?.activeProfiles?.length === 1)
                    commit('setSubscriptionData', {profiles: [state.newsletterData?.activeProfiles[0].id]})
                else
                    commit('setSubscriptionData', {profiles: []})
            }
            commit('setNewsletterIsLoaded', true)
            if (responseData.ci) {
                useNuxtApp().$applyCi(responseData.ci, {standalone: true})
            }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 404) {
                    showError({statusCode: 403, message: "not_found"})
                } else if (error.response.status === 403) {
                    showError({statusCode: 403, message: error.response.data?.message, data: error.response.data})
                } else if (error.response.status === 500) {
                    showError({statusCode: 500})
                }
            } else {
                console.log(error)
            }
        }
    },

    async sendSubscription({commit, state}) {
        try {
            commit('setNewsletterIsLoaded', false)
            let response = null;
            if (state.subscriptionData.id && state.unsubscribe) {
                response = await useNuxtApp().$axios.delete(useNuxtApp().$apiRoute('api.newsletters.newsletters.subscriptions.destroy', {
                        newsletter: state.newsletterData?.id,
                        subscription: state.subscriptionData.id
                    }),
                    {
                        params: {
                            subscriberToken: state.subscriberToken
                        }
                    }
                )
                commit('setSubscriptionData', {})
            } else if (state.subscriptionData.id) {
                response = await useNuxtApp().$axios.patch(useNuxtApp().$apiRoute('api.newsletters.newsletters.subscriptions.update', {
                        newsletter: state.newsletterData?.id,
                        subscription: state.subscriptionData.id
                    }),
                    {
                        ...state.subscriptionData,
                        subscriberToken: state.subscriberToken
                    }
                )
            } else {
                response = await useNuxtApp().$axios.post(useNuxtApp().$apiRoute('api.newsletters.newsletters.subscriptions.store', {newsletter: state.newsletterData?.id}),
                    {...state.subscriptionData}
                )
                commit('setSubscriptionProp', {prop: "id", value: response.data.id})
            }
            commit('setSubscriptionFinishedSuccessful', true)
            commit('setNewsletterIsLoaded', true)
            return response
        } catch (e) {
            console.log(e)
            commit('setNewsletterIsLoaded', true)
            if (e.response && e.response.data && registeredErrorMessages.includes(e.response.data.message)) {
                useNuxtApp().$notify({
                    type: 'danger',
                    message: useNuxtApp().$i18n.t('error.' + e.response.data.message),
                    timeout: 15000
                })
            } else {
                useNuxtApp().$notify({
                    type: 'danger',
                    message: useNuxtApp().$i18n.t('error.errorWhileSubscription'),
                    timeout: 15000
                })
            }
        }
    }
}